import { getHistoricalData } from "@/_core/data/api_calls/candle_data/getHistoricalData";
import { formatDate_YMDHMS, roundDateToFloor } from "@/_core/_helpers/_helpers";
import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves historical technical analysis data for currencies from the API gateway.
 *
 * @param {object} _this - The context object containing necessary parameters.
 * @param {object} [assetExtraParams={}] - Optional parameters, including the currency number.
 * @returns {Promise<object>} - A promise resolving to the historical data.
 */
export function getCandleTechnicalAnalysisCurrencies(
  _this,
  assetExtraParams = {},
) {
  const currency =
    assetExtraParams &&
    Object.keys(assetExtraParams).length === 0 &&
    Object.getPrototypeOf(assetExtraParams) === Object.prototype
      ? _this.currencyNumber
      : assetExtraParams.currencyNumber;
  const variables = {
    format: "json",
    currency,
    observation_date: formatDate_YMDHMS(
      roundDateToFloor(_this.initCurrencyDate),
    ),
  };
  return getHistoricalData(_this, {
    // TODO: verificar endpoint — currencies.py no tiene /technical-analysis
    // propio; se asume que total_technicalanalysis_historical (market router)
    // cubre currencies via el parametro `currency`. Confirmar contra el
    // gateway corriendo (/docs) o el backend Django antes de dar por cerrado.
    fetch: gatewayService.market.technicalAnalysis,
    variables,
    source: "technical_analysis_historical",
  }).catch((error) => {
    console.error("Error from technical_analysis_historical:", error);
    throw error;
  });
}
